export const endpoints = {
    goalsOptions: 'goals/company/companyUUID/solution-goal-card-options/',
    myGoal: '/goals/company/companyUUID/my-goals/',
    insightData: '/goals/company/companyUUID/insight-data/',
}
